import { render, staticRenderFns } from "./Ecritures.vue?vue&type=template&id=098ff300&scoped=true"
import script from "./Ecritures.vue?vue&type=script&lang=ts"
export * from "./Ecritures.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098ff300",
  null
  
)

export default component.exports